import { styled } from 'mz-ui-kit'

// Constants
const APPEARANCE_THEME = {
  primary: {
    color: 'GREEN',
    background: 'GREEN',
    alpha: 0.2,
  },
  inverted: {
    color: 'PRIMARY',
    background: 'WHITE',
    alpha: 1,
  },
  return: {
    color: 'ORANGE',
    background: 'ORANGE',
    alpha: 0.4,
  },
}

export const Dot = styled('div', ({ $grouped, $palette }) => ({
  height: '14px',
  width: '14px',
  flexShrink: 0,
  margin: $grouped ? '0 20px' : '0',
  background: `${$palette('PRIMARY')}`,
  border: `2px solid ${$palette('WHITE')}`,
  borderRadius: '50%',
  zIndex: 1,
}))

export const Line = styled('div', ({ $appearance, $palette }) => {
  const { background, alpha } = APPEARANCE_THEME[$appearance]
  return {
    height: '8px',
    background: `${$palette(background).setAlpha(alpha)}`,
    position: 'absolute',
    left: 0,
    right: 0,
  }
})

export const DotWithLine = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  height: '15px',
})

export const Timeline = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: '15px',
  flexGrow: 1,
})

export const Step = styled('div', ({ $grow }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: $grow > 0 ? $grow : 0,
  justifyContent: 'flex-start',
  alignItems: 'center',
}))

export const Text = styled('div', {
  fontSize: '10px',
  maxWidth: '140px',
  textAlign: 'center',
})

export const TextItem = styled('span', {
  ':not(:last-child)': {
    ':after': {
      content: '" / "',
      display: 'inline',
    },
  },
})

export const Time = styled('p', {
  fontSize: '18px',
  fontWeight: 'bold',
  margin: '10px 0',
  whiteSpace: 'nowrap',
})

export const Icons = styled('div', {
  display: 'flex',
  flexFlwo: 'row nowrap',
  height: '30px',
  marginBottom: '5px',
})

export const Icon = styled('div', ({ $grouped, $palette }) => ({
  fontSize: '24px',
  margin: $grouped ? '0 10px' : '0',
  color: `${$palette('PRIMARY')}`,
}))
